// Direct import, not the barrel: that re-exports the editor controls and would
// drag @wordpress/components and React into the frontend bundle.
import { bootstrapScenes } from '@components/MediaSlot/sceneRuntime';

bootstrapScenes();
